<template>
    <card-normal>
        <template #sections>
            <card-section area="card-header">
                <text-decorator bold>
                    <slot name="title" />
                </text-decorator>
            </card-section>
        </template>
        <flex-container :gap="Size.sm">
            <div v-if="!props.editable">
                <user-team-block-legacy
                    :user="props.user"
                    :team="props.team"
                />
            </div>
            <input-group
                v-else
                v-model="currentUser"
            >
                <template #input>
                    <select-input
                        :items="assignableUsers ?? []"
                        value-key-name="id"
                        label-key-name="name"
                        variant="inline"
                    >
                        <template #active>
                            <user-team-block-legacy
                                :user="currentUser"
                                :team="props.team"
                            />
                        </template>
                        <template #item="{ bindings }">
                            <span style="display:flex; align-items: center;">
                                <user-avatar
                                    :placeholder="bindings.item.name.abbreviation"
                                    size="md"
                                    :url="bindings.item.avatar ? resizedToSizeUploadUrl(bindings.item.avatar, 'md') : ''"
                                    :alt="bindings.item.name"
                                />
                                <span>&nbsp;{{ bindings.item.name }}</span>
                            </span>
                        </template>
                    </select-input>
                </template>
            </input-group>
            <transition name="fade">
                <flex-container
                    v-if="hasChanges"
                    :gap="Size.sm"
                    justify-content="flex-end"
                >
                    <button-outline @click="cancel">
                        Annuleren
                    </button-outline>
                    <button-block @click="submit">
                        Opslaan
                    </button-block>
                </flex-container>
            </transition>
        </flex-container>
    </card-normal>
</template>

<script setup lang="ts">
    import {
        CardNormal,
        CardSection,
        TextDecorator,
        SelectInput,
        InputGroup,
        UserAvatar,
        Size,
        ButtonOutline,
        FlexContainer,
        ButtonBlock,
    } from '@keyvue/one-ui';

    import UserTeamBlockLegacy from '@components/Blocks/UserTeamBlockLegacy.vue';

    import type { User, Branch } from '@keyvue/one-api-client-legacy';
    import { resizedToSizeUploadUrl } from '@/utils/resize';
    import { ref, type Ref, watch } from 'vue';

    export interface Props {
        user: User | null
        team: Branch | null
        editable?: boolean
        assignableUsers?: User[]
    }

    const emit = defineEmits(['user-change']);
    const props = defineProps<Props>();
    const currentUser = ref<User | null>(props.user) as Ref<User | null>;
    const hasChanges = ref(false);

    const submit = () => {
        emit('user-change', currentUser.value);
        hasChanges.value = false;
    };

    const cancel = () => {
        currentUser.value = props.user;
        hasChanges.value = false;
    };

    watch(currentUser, () => {
        hasChanges.value = currentUser.value?.id !== props.user?.id;
    });

    watch(props, () => {
        currentUser.value = props.user;
    });
</script>
